import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { loadMemberData, loadMemberDataSuccess, loadMemberDataFailure } from '../actions/members.actions';
import { environment } from 'src/environments/environment';
import { selectMemberData } from '../selectors/member.selector';
import { select, Store } from '@ngrx/store';
import { decompress } from 'compress-json';
import { decryption } from 'src/app/common-functions';

// @Injectable()
// export class MemberEffects {
//   loadMemberData$;
//   constructor(private actions$: Actions, private http: HttpClient, private store: Store) {
//     this.loadMemberData$ = createEffect(() =>
//       this.actions$.pipe(
//         ofType(loadMemberData),
//         withLatestFrom(this.store.pipe(select(selectMemberData))),
//         switchMap(([action, currentData]) => {
//           if (currentData != undefined && currentData.length > 0) {
//             console.log('Data already in store, no need to call API');
//             console.log('return old fetch',new Date().toISOString())
//             return;
//             // return [loadMemberDataSuccess({ memberData: currentData })]; // Return the existing data
//           }

//           const api = this.getApiEndpoint();
//           const apiUrl = `${environment.apiUrl.replace(/\/$/, '')}${api}`;
//           const headers = {
//             'Authorization': `Bearer ${sessionStorage.getItem('accessToken')}`,
//             'Content-Type': 'application/json'
//           };
//           return this.http.get<any>(apiUrl, { headers }).pipe(
//             map((data) => {
//               console.log('Fetched new data:', data);
//               console.log('new fetch',new Date().toISOString())
//               const role = sessionStorage.getItem('role')
//               if(role=='ADMINISTRATOR'){
//                 return loadMemberDataSuccess({ memberData: decompress(data.data) }); // Dispatch success with new data
//               }else{
//                 return loadMemberDataSuccess({ memberData: data.data }); // Dispatch success with new data
//               }
//             }),
//             catchError((error) => {
//               console.error('API Error:', error);
//               const errorMessage = error?.message || 'An unknown error occurred';
//               return [loadMemberDataFailure({ error: errorMessage })]; // Dispatch failure on error
//             })
//           );
//         })
//       )
//     );
//   }

//   private getApiEndpoint(): string {
//     const role = sessionStorage.getItem('role');
//     console.log('Role from sessionStorage:', role);
//     if (!role || role === 'USER') {
//       return '/api/ap/admin/customers/list';
//     } else if (role === 'ADMINISTRATOR') {
//       return '/api/ap/global/adminMembers';
//     } else {
//       return '/api/ap/admin/customers/list';
//     }
//   }
// }


// 2nd 
@Injectable()
export class MemberEffects {
  loadMemberData$;
  constructor(private actions$: Actions, private http: HttpClient, private store: Store) {
    this.loadMemberData$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadMemberData),
        withLatestFrom(this.store.pipe(select(selectMemberData))),
        switchMap(([action, currentData]) => {
          // if (currentData != undefined && currentData.length > 0) {
          //   console.log('Data already in store, no need to call API');
          //   console.log('return old fetch',new Date().toISOString())
          //   return;
          //   // return [loadMemberDataSuccess({ memberData: currentData })]; // Return the existing data
          // }

          const api = this.getApiEndpoint();
          const apiUrl = `${environment.apiUrl.replace(/\/$/, '')}${api}`;
          const headers = {
            'Authorization': `Bearer ${sessionStorage.getItem('accessToken')}`,
            'Content-Type': 'application/json'
          };

          return this.http.get<any>(apiUrl, { headers }).pipe(
            map((data) => {
              console.log('Fetched new data:', data);
              console.log('New fetch', new Date().toISOString());
              
              if (data && data.data && data.data.length > 0) {
                console.log('entered memberData udpation')
                // API returned data, replace both sessionStorage and store
                
                const role = sessionStorage.getItem('role');
                let dataToStore = data.data;
                
                if (role == 'ADMINISTRATOR') {
                  sessionStorage.setItem('memberData', JSON.stringify(decompress(data.data)));
                  // Decompress data if role is ADMINISTRATOR
                  dataToStore = decompress(data.data);

                  dataToStore = dataToStore.map((customer: any)=>JSON.parse(decryption(customer)));
                }

                return loadMemberDataSuccess({ memberData: dataToStore });
              } else {
                // API returned no data, use sessionStorage data if available
                const cachedData = sessionStorage.getItem('memberData');

                if (cachedData) {
                  console.log('Returning data from sessionStorage', new Date().toISOString());
                  return loadMemberDataSuccess({ memberData: JSON.parse(cachedData) });
                } else {
                  console.log('No data in sessionStorage', new Date().toISOString());
                  return loadMemberDataFailure({ error: 'No member data available' });
                }
              }
            }),
            catchError((error) => {
              console.error('API Error:', error);
              const errorMessage = error?.message || 'An unknown error occurred';
              return [loadMemberDataFailure({ error: errorMessage })];
            })
          );
        })
      )
    );
  }

   private getApiEndpoint(): string {
    const role = sessionStorage.getItem('role');
    console.log('Role from sessionStorage:', role);
    if (!role || role === 'USER') {
      return '/api/ap/admin/customers/list';
    } else if (role === 'ADMINISTRATOR') {
      return '/api/ap/global/adminMembers';
    } else {
      return '/api/ap/admin/customers/list';
    }
  }
}

